<template>
    <div class="job-title-ended-task loading-container">
        <loading :active="loading" :is-full-page="false" />

        <template v-if="!loading">
            <div class="task-body">
                <JobLink :companyId="title.companyId" :executiveId="title.executiveId" />

                <h2>Job Title Ended</h2>

                <dl>
                    <dt>Confirmed Date</dt>
                    <dd>{{ jobHistoryConfirmedDate }}</dd>
                    <dt>Company Name</dt>
                    <dd>{{ company.name }}</dd>
                    <dt>Title</dt>
                    <dd>{{ title.title }}</dd>
                </dl>

                <form @submit.prevent>
                    <mt-input
                        type="date"
                        v-model="title.startDate"
                        label="Start Date"
                        @update:modelValue="markChanged"
                    />
                    <mt-input type="date" v-model="title.endDate" label="End Date" @update:modelValue="markChanged" />
                    <mt-checkbox v-model="title.active" label="Active" @update:modelValue="markChanged" />
                </form>

                <InputError :errorMessage="errors" />
            </div>

            <div class="task-actions">
                <button @click="completeTask" class="primary">Complete</button>
            </div>
        </template>
    </div>
</template>

<script>
import TaskService from '@/services/manage/taskService'
import InputError from '@/components/shared/forms/input-error'
import CompanyService from '@/services/manage/companyService'
import { JobTitlesService } from '@/services/manage/JobTitlesService'
import JobLink from '@/components/manage/tasks/Jobs/JobLink'
import { Status } from '@/utils/request'
import ExecutiveService from '@/services/manage/executiveService'

export default {
    components: { JobLink, InputError },
    props: {
        task: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            changed: false,
            errors: [],
        }
    },
    computed: {
        executiveId() {
            return this.task.primaryEntityId
        },
        titleId() {
            return this.task.secondaryEntityId
        },
        loading() {
            return (
                this.$asyncComputed.company.updating ||
                this.$asyncComputed.title.updating ||
                this.$asyncComputed.jobHistoryConfirmedDate.updating
            )
        },
    },
    asyncComputed: {
        company: {
            async get() {
                if (this.title?.companyId) {
                    return await CompanyService.get(this.title.companyId)
                }

                return {}
            },
            default() {
                return {}
            },
        },
        jobHistoryConfirmedDate: {
            async get() {
                return await ExecutiveService.getJobHistoryConfirmedDate(this.executiveId)
            },
            default: null,
        },
        title: {
            async get() {
                let title = await JobTitlesService.get(this.titleId)

                return {
                    ...title,
                    startDate: title.startDate?.substring(0, 10),
                    endDate: title.endDate?.substring(0, 10),
                }
            },
            default() {
                return {}
            },
        },
    },

    methods: {
        markChanged() {
            this.changed = true
        },
        async completeTask() {
            if (this.changed) {
                let { ok, status, content } = await JobTitlesService.update(this.titleId, this.title)

                if (!ok) {
                    if (status === Status.UNPROCESSABLE_ENTITY) {
                        this.$flash('An error occurred when updating this job title.', 'error')
                        this.errors = Object.values(content).flat()
                    } else {
                        this.$flash('An unknown error occurred when updating this job title.', 'error')
                    }

                    return
                }
            }

            await TaskService.complete(this.task)
            this.$flash('Job title updated successfully.', 'success')
        },
    },
}
</script>
